import axios from 'config/axios';
import { getLocalStorageValue, setLocalStorageValue } from './helper';

export async function getNearestStoreByZip(storeList, zipToFind, isLocationPermissionGranted) {
  let destinationLocation
  if (zipToFind) {
    const exactZipcodeMatchFound = storeList.filter(item => item.ZipCode === zipToFind)
    if (exactZipcodeMatchFound?.length) {
      return exactZipcodeMatchFound
    }
    destinationLocation = await getLocationFromZip(zipToFind)
  } else if (isLocationPermissionGranted) {
    try {
      destinationLocation = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            });
          },
          (error) => {
            reject(error);
          }
        );
      });
    } catch (error) {
      console.error("Error getting user location", error);
    }
  }

  if (!destinationLocation?.latitude) {
    return
  }

  let items = [...storeList].map(item => {
    return {
      ...item,
      miles: getDistance(item, destinationLocation)
    }
  })
  items.sort((a, b) => {
    const aMiles = a.miles
    const bMiles = b.miles

    if (aMiles < bMiles) {
      return -1
    } else if (aMiles > bMiles) {
      return 1
    } else {
      return 0
    }
  }); 

  return items
}

async function getLocationFromZip(zip) {
  try {
    if (!zip) return null
  
    const cached = JSON.parse(getLocalStorageValue("_zipToLocation") || "{}")
    if (cached?.[zip]) {
      return cached?.[zip] || {}
    }
  
    const RSAClientId = getLocalStorageValue("RSAclient-id")
    const response = await axios.post('/AogGetZipCodeLocation', {
      RSAClientId,
      zipcode: zip
    });
    if (response?.data?.status === "error") {
      return {}
    }
  
    const newData =  {
      ...(cached?.[zip] || {}),
      [zip]: response?.data?.data?.[0]
    }

    setLocalStorageValue("_zipToLocation", JSON.stringify(newData))
    return newData?.[zip] || {}
  } catch (error) {
    console.log('❌ ERROR getting location from zip ', error)
    return {}
  }
}

function getDistance(loc1, loc2) {
  const lat1 = parseFloat(loc1?.Latitude)
  const lon1 = parseFloat(loc1?.Longitude)
  const lat2 = parseFloat(loc2?.latitude)
  const lon2 = parseFloat(loc2?.longitude)

  if (!lat1 || !lon1 || !lat2 || !lon2) {
    return 0;
  }

  const R = 3958.8; // Radius of the Earth in miles
  const toRad = deg => deg * Math.PI / 180;

  
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a = Math.sin(dLat/2)**2 +
            Math.cos(toRad(lat1)) *
            Math.cos(toRad(lat2)) *
            Math.sin(dLon/2)**2;

  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}